<div class="main-page cadastros journey-main">
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-12 my-2">
        <h1>Tempo e Movimento</h1>
      </div>
    </div>
    <div
      style="
        background-color: #1e3f7a;
        padding: 10px 20px;
        border-radius: 4px;
        margin-bottom: 20px;
      "
      class="d-flex justify-content-between align-items-center flex-wrap"
    >
      <div>
        <button mat-button (click)="onOpenDialogFilter()" style="color: white">
          <mat-icon style="color: white">filter_list</mat-icon>
          Filtrar
        </button>
      </div>
      <div>
        <button
          mat-stroked-button
          (click)="exportExcel()"
          style="color: white; border-color: white; margin-right: 10px"
        >
          <mat-icon style="color: white">table_view</mat-icon>
          Excel
        </button>
        <button
          mat-stroked-button
          (click)="exportPdf()"
          style="color: white; border-color: white"
        >
          <mat-icon style="color: white">picture_as_pdf</mat-icon>
          PDF
        </button>
      </div>
    </div>

    <mat-horizontal-stepper [linear]="true" #stepper>
      <mat-step>
        <!-- COMECA -->
        <div class="ignition-table-wrapper">
        <p-table
          #journeyheader
          [value]="this.resultadoAnalitico"
          tableStyleClass="tableAnalitico"
        >
          <ng-template pTemplate="header" let-columns>
            <tr
              [hidden]="this.resultadoAnalitico.length == 0"
              id="tabela-analitico"
              [ngClass]="this.filterDialog == true ? '' : 'sticky-top'"
            >
              <th class="linha-analitico col-data">Data</th>
              <th class="linha-analitico col-hora">Hora Inicio/Fim</th>
              <th class="linha-analitico col-placa">Placa</th>
              <th class="linha-analitico col-frota">Frota</th>
              <th class="linha-analitico col-motorista">Motorista</th>
              <th class="linha-analitico col-status">Status Ignição</th>
              <th class="linha-analitico col-km">KM Percorrido</th>
              <th class="linha-analitico col-tempo">Tempo</th>
            </tr>
          </ng-template>

          <br />
          <ng-template pTemplate="body" let-rowdata>
            <tr>
              <td class="col-data" [pRowToggler]="rowdata">
                {{ rowdata["dia"] }}
              </td>
              <td class="col-hora" [pRowToggler]="rowdata">
                {{ rowdata["horarioIgnicao"] }}
              </td>
              <td class="col-placa" [pRowToggler]="rowdata">
                {{ rowdata["placa"] }}
              </td>
              <td class="col-frota" [pRowToggler]="rowdata">
                {{ rowdata["frota"] }}
              </td>
              <td class="col-motorista" [pRowToggler]="rowdata">
                {{ rowdata["motoristaNome"] }}
              </td>
              <td
                *ngIf="rowdata['statusIgnicao'] == 'PARADO'"
                class="col-status status-parado"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["statusIgnicao"] }}
              </td>
              <td
                *ngIf="rowdata['statusIgnicao'] == 'MOVIMENTO'"
                class="col-status status-movimento"
                [pRowToggler]="rowdata"
              >
                {{ rowdata["statusIgnicao"] }}
              </td>
              <td class="col-km" [pRowToggler]="rowdata">
                {{ rowdata["kmPercorridoDia"] }} KM
              </td>
              <td class="col-tempo" [pRowToggler]="rowdata">
                {{ rowdata["tempoIgnicao"] }}
              </td>
            </tr>
          </ng-template>
        </p-table>
        </div>
        <!-- FIM-->
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>

<p-sidebar [(visible)]="this.filterDialog" position="right">
  <div style="margin-bottom: 20px">
    <span>Filtros</span>
  </div>
  <form [formGroup]="this.consultaFormGroup">
    <div class="form-row">
      <div class="form-group col-lg-12">
        <mat-form-field appearance="outline">
          <mat-label>Tipo de Relatório</mat-label>
          <mat-select
            formControlName="tipoRelatorio"
            (selectionChange)="onTipoRelatorioChange()"
          >
            <mat-option value="DRIVER">Por Motorista</mat-option>
            <mat-option value="VEHICLE">Por Veículo</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-lg-12">
        <mat-form-field appearance="outline">
          <mat-label>Data Início</mat-label>
          <input
            formControlName="dataInicio"
            type="date"
            matInput
            placeholder="Inicio"
            required
          />
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-lg-12">
        <mat-form-field appearance="outline">
          <mat-label>Data Fim</mat-label>
          <input
            formControlName="dataFim"
            type="date"
            matInput
            placeholder="Fim"
            required
          />
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-8">
        <mat-form-field appearance="outline">
          <mat-label>Tipo de Empresa</mat-label>
          <mat-select
            formControlName="selecaoEmpresa"
            [(value)]="empresaFilterSelected"
            [(ngModel)]="empresaFilterSelected"
            (selectionChange)="this.filterCompanyReports()"
          >
            <mat-option
              *ngFor="let type of companiesSelect"
              [value]="type.name"
            >
              {{ type.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-8">
        <mat-form-field appearance="outline">
          <mat-label>Empresa</mat-label>
          <input
            type="text"
            matInput
            [formControl]="controlEmpresa"
            [matAutocomplete]="autoEmpresa"
            required
          />
          <mat-autocomplete
            #autoEmpresa="matAutocomplete"
            [displayWith]="displayEmpresa"
          >
            <mat-option
              *ngFor="let type of this.companiesFilter"
              [value]="type"
            >
              {{ type.nmNome }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-8">
        <mat-form-field appearance="outline" *ngIf="controlEmpresa.value != ''">
          <mat-label>Motorista</mat-label>
          <input
            type="text"
            matInput
            [formControl]="controlMotorista"
            [matAutocomplete]="autoMotorista"
            [disabled]="tipoRelatorioSelecionado !== 'DRIVER'"
          />
          <mat-autocomplete
            #autoMotorista="matAutocomplete"
            [displayWith]="displayMotorista"
          >
            <mat-option
              *ngFor="let type of this.driversFiltered | async"
              [value]="type"
            >
              {{ type.nmNome }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-8">
        <mat-form-field appearance="outline" *ngIf="controlEmpresa.value != ''">
          <mat-label>Placa / Frota</mat-label>
          <input
            type="text"
            matInput
            [formControl]="controlVeiculo"
            [matAutocomplete]="autoTerminal"
            [disabled]="tipoRelatorioSelecionado !== 'VEHICLE'"
          />
          <mat-autocomplete
            #autoTerminal="matAutocomplete"
            [displayWith]="displayTerminal"
          >
            <mat-option
              *ngFor="let type of this.vehiclesFiltered | async"
              [value]="type"
            >
              {{ type.cdPlaca }}/{{ type.frota }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-8">
        <button type="submit" (click)="onConsultar()">Consultar</button>
      </div>
    </div>
  </form>
</p-sidebar>
